import getActiveTab from './utility/get-active-tab';

const timespanScopeAllTimeUI = document.querySelector('#timespan-scope-all-time');
const timespanScopeFromDateUI = document.querySelector('#timespan-scope-from-time');
const timespanScopeFromDatepicker = document.querySelector('#time_from_date');
const downloadButton = document.querySelector('#download_button');
const mainForm = document.querySelector('#main-form');
const activeTab = getActiveTab(mainForm);
const allTimeRecordTypeUI = document.getElementsByName('all_time_record_type');
const limitedTimeRecordTypeUI = document.getElementsByName('limited_time_record_type');
const includeCodesTextareaLabel = document.querySelector('[data-js="include-codes"]');

class FiltersDownload {
	constructor(recordsCount) {
		this.recordsCount = recordsCount;
		this._recordsDebouncer = undefined;
		this._addSelectedFilterClickListener(timespanScopeAllTimeUI);
		this._addSelectedFilterClickListener(timespanScopeFromDateUI);
		this._datepickerBlurListener(timespanScopeFromDatepicker);
		this._datepickerChangeListener(timespanScopeFromDatepicker);
		this._setFormUpdateListener();
		// event for update records count on ui change. This event is polyfilled (see ../vendor.js)
		if (mainForm !== null) {
			mainForm.dispatchEvent(new CustomEvent('change'));
		}
	}

	setDownloadButtonStatus(status) {
		if (status) {
			this.enableDownloadButton();
		} else {
			this.disableDownloadButton();
		}
	}

	disableDownloadButton() {
		if (downloadButton) {
			downloadButton.setAttribute('disabled', 'true');
		}
	}

	enableDownloadButton() {
		downloadButton.removeAttribute('disabled');
	}

	_addSelectedFilterClickListener(element) {
		if (element) {
			element.addEventListener('click', () => {
				this._checkSelectedFilter();
			});
		}
	}

	_datepickerChangeListener(element) {
		if (element) {
			element.addEventListener('change', () => {
				this._validateDatePicker(this._isDateValid());
			});
		}
	}

	_datepickerBlurListener(element) {
		if (element) {
			element.addEventListener('blur', () => {
				this._validateDatePicker(this._isDateValid());
			});
		}
	}

	_checkSelectedFilter() {
		if (timespanScopeFromDateUI.checked) {
			this._enableTimescope(limitedTimeRecordTypeUI);
			this._disableDatePicker(false);
			this._handleDefaultState(limitedTimeRecordTypeUI);
			if (getActiveTab(mainForm) === 'books') {
				this._disableTimescope(allTimeRecordTypeUI);
			}
			return false; // return boolean info ui to pass into the records Count component for make record ui react on that info
		}
		this._validateDatePicker(true);
		this._disableTimescope(limitedTimeRecordTypeUI);
		this._disableDatePicker(true);
		if (getActiveTab(mainForm) === 'books') {
			this._enableTimescope(allTimeRecordTypeUI);
			this._handleDefaultState(allTimeRecordTypeUI);
		}
		return true; // info used in this._setFormUpdateListener()
	}

	_handleDefaultState(target) {
		// check if at least one radio is selected, otherwise set default
		if (!this._checkIfDefaultSelection(target)) {
			this._setDefaultSelection(target);
		}
	}

	_disableTimescope(recordTypeUI) {
		if (recordTypeUI) {
			for (const item of Array.from(recordTypeUI)) {
				if (item) {
					item.checked = false;
					item.disabled = true;
				}
			}
		}
	}

	_enableTimescope(recordTypeUI) {
		if (recordTypeUI) {
			for (const item of Array.from(recordTypeUI)) {
				if (item) {
					item.disabled = false;
				}
			}
		}
	}

	_disableDatePicker(change) {
		timespanScopeFromDatepicker.disabled = change;
	}

	_setFormUpdateListener() {
		if (mainForm) {
			mainForm.addEventListener('change', event => {
				if (event.target.name && ['download_file_format', 'group_by_ebook_package', 'group_by_year'].includes(event.target.name)) {
					event.stopPropagation();
				} else if (event.target === timespanScopeAllTimeUI) {
					this._resetDatePickerValue();
					this.callWithTimeout();
				} else if (event.target === timespanScopeFromDateUI) {
					if (this._isDateValid() === false) {
						this._recordsExistUI(false);
					} else {
						this._recordsExistUI(true);
						this.callWithTimeout();
					}
				// If one of the 3 sub options (of timespanScopeFromDateUI) gets selected
				} else if (this._isDateValid() === false) {
					this._validateDatePicker(false);
				} else {
					this.callWithTimeout();
				}
			});
		}
	}

	callWithTimeout() {
		clearTimeout(this._recordsDebouncer);

		// note: keep setTimeout because its a IE trick to make records count work
		this._recordsDebouncer = setTimeout(() => {
			this.recordsCount.displayTotalRecordsCount(this._checkSelectedFilter())
				.then(data => {
					if (data.error === undefined) {
						this._handleErrorOnTextarea('remove');
						this._recordsExistUI(this.recordsCount.hasAnyRecords());
					} else {
						this._handleErrorOnTextarea('add');
						this._recordsExistUI(false);
					}
				})
				.catch(() => {
					this._recordsExistUI(true);
					this.recordsCount.errorTotalCount();
				});
		}, 1500);
	}

	_resetDatePickerValue() {
		timespanScopeFromDatepicker.value = '';
	}

	_recordsExistUI(recordsExist) {
		if (!recordsExist) {
			this.recordsCount.disableTotalCount();
		}
		this.setDownloadButtonStatus(recordsExist);
	}

	_handleErrorOnTextarea(toggleState) {
		const typeToIncludeExclude = activeTab === 'books' ? 'ISBNs' : 'ISSNs';
		const errorMessageElementExists = includeCodesTextareaLabel.nextElementSibling.classList.contains('c-input__validation-text--errored');
		const errorMessageTemplate = `
	  	<svg fill="currentColor" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 			<path d="m10.838 15.551h2.3462v2.3462h-2.3462zm0-9.3849h2.3462v7.0386h-2.3462zm1.1614-5.8655c-6.4755 0-11.719 5.2555-11.719 11.731 0 6.4755 5.2438 11.731 11.719 11.731 6.4873 0 11.743-5.2555 11.743-11.731 0-6.4755-5.2555-11.731-11.743-11.731zm0.011731 21.116a9.3819 9.3819 0 0 1-9.3849-9.3849c0-5.1851 4.1997-9.3849 9.3849-9.3849 5.1851 0 9.3849 4.1997 9.3849 9.3849 0 5.1851-4.1997 9.3849-9.3849 9.3849z" stroke-width="1.4664"/>
		</svg>

	  <span>In total 15000 ` + typeToIncludeExclude + ` can be included and/or excluded from the download.</span>`;

		const messageWrapper = document.createElement('p');
		messageWrapper.className = 'c-input__validation-text--errored';
		messageWrapper.innerHTML = errorMessageTemplate;

		if (!errorMessageElementExists && toggleState === 'add') {
			includeCodesTextareaLabel.after(messageWrapper);
		} else if (errorMessageElementExists && toggleState === 'remove') {
			const errorMessageElement = includeCodesTextareaLabel.nextElementSibling;
			errorMessageElement.remove();
		}
	}

	_insertDatePickerErrorMessage() {
		return timespanScopeFromDatepicker.insertAdjacentHTML('afterend', '<div class="c-datepicker__validation-msg--error">Choose a date</div>');
	}

	_validateDatePicker(status) {
		const errorMessageElement = document.querySelector('.c-datepicker__validation-msg--error');
		if (status) {
			timespanScopeFromDatepicker.classList.remove('c-datepicker--invalid');
		} else {
			timespanScopeFromDatepicker.classList.add('c-datepicker--invalid');
			if (!errorMessageElement) {
				this._insertDatePickerErrorMessage();
			}
		}
	}

	_isDateValid() {
		let validState = true;

		if (timespanScopeFromDateUI.checked === true) {
			const datePickedString = timespanScopeFromDatepicker.value;
			const datePickedValue = (datePickedString ? new Date(datePickedString).getTime() : '');
			const minDateString = new Date(timespanScopeFromDatepicker.getAttribute('min'));
			const maxDateString = new Date(timespanScopeFromDatepicker.getAttribute('max'));
			const minDateValue = minDateString.getTime();
			const maxDateValue = maxDateString.getTime();

			validState = datePickedString === '' ? false : (minDateValue >= datePickedValue || datePickedValue <= maxDateValue);
		}

		return validState;
	}

	_checkIfDefaultSelection(target) {
		let oneChecked = false;
		for (const element of Array.from(target)) {
			if (element.checked) {
				oneChecked = true;
			}
		}
		return oneChecked;
	}

	_setDefaultSelection(elementsArray) {
		elementsArray[0].checked = true;
	}
}

export default FiltersDownload;
